import axios from "axios";
import AppContext from "../../../context/AppContext";
import { useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Container } from "react-bootstrap";
import { CloudUpload, FileEarmark, XCircle } from "react-bootstrap-icons";
import "../../../assets/css/Drivers/DriverKyc/VehicleUpload.css";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

// Ek reusable upload box, vehicle aur license dono ke liye
const UploadBox = ({ label, file, onChange }) => {
  const inputRef = useRef();

  const handleSelect = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;
    if (selected.size > MAX_FILE_SIZE) {
      alert("File size must be less than 5MB.");
      e.target.value = "";
      return;
    }
    onChange(selected);
  };

  return (
    <div className="mb-3">
      <p className="vu-subtitle">{label}</p>
      <div className="vu-upload" onClick={() => inputRef.current.click()}>
        <input
          type="file"
          hidden
          ref={inputRef}
          accept="image/*,.pdf"
          onChange={handleSelect}
        />
        {file ? (
          <>
            <FileEarmark size={40} className="vu-icon" />
            <div className="vu-file-name">{file.name}</div>
            <XCircle
              size={22}
              className="vu-remove"
              onClick={(e) => {
                e.stopPropagation();
                onChange(null);
                inputRef.current.value = ""; // wahi file dobara select ho sake
              }}
            />
          </>
        ) : (
          <>
            <CloudUpload size={45} className="vu-icon" />
            <p>Click to Upload</p>
          </>
        )}
      </div>
    </div>
  );
};

const VehicleUpload = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const navigate = useNavigate();
  const [vehicle_document, setVehicle_document] = useState(null);
  const [driving_license, setDriving_license] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!vehicle_document) {
      alert("Please upload vehicle document.");
      return;
    }
    if (!driving_license) {
      alert("Please upload driving license.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("vehicle_document", vehicle_document);
    formData.append("driving_license", driving_license);

    // Content-Type header nahi lagana, axios boundary khud set karta hai
    axios
      .post(`${baseUrl}/general/kyc/uploadVehicle`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(() => {
        setLoading(false);
        alert("Documents submitted successfully.");
        navigate("/driver-login");
      })
      .catch((error) => {
        setLoading(false);
        console.log(error.response);
        alert(error.response?.data?.message || "Upload failed.");
      });
  };

  return (
    <div className="vu-wrapper">
      <Container>
        <Card className="vu-card">
          <h2 className="vu-title">Vehicle Verification</h2>

          <UploadBox
            label="Upload your vehicle registration document."
            file={vehicle_document}
            onChange={setVehicle_document}
          />

          <UploadBox
            label="Upload your driving license."
            file={driving_license}
            onChange={setDriving_license}
          />

          <Button className="vu-btn" onClick={handleSubmit} disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </Card>
      </Container>
    </div>
  );
};

export default VehicleUpload;